import React, { useState } from 'react';
import cx from 'clsx';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as ExpandRowIcon } from '@assets/svg/executive-summary/ic-expand-row.svg';

import EquipmentByFaultTable from '../EquipmentByFaultTable/EquipmentByFaultTable';

import type { IFailureCauseCategories } from '../../model/failureCauseCategories';

import style from './style.module.scss';

interface IProps {
  row: IFailureCauseCategories;
}

const ExpandedRow: React.FC<IProps> = ({ row }) => {
  const [isVisibleHiddenRow, setVisibleHiddenRow] = useState(false);

  return (
    <>
      <tr className={style.bodyRow} key={`bodyRow-${row.fault_id}`}>
        <td>{row.fault_name}</td>
        <td>{row.action_items_count}</td>
        <td
          className={style.iconColumn}
          onClick={() => setVisibleHiddenRow((prev) => !prev)}
        >
          <ExpandRowIcon
            className={cx(style.expandRowIcon, { [style.expandRowIconTop]: isVisibleHiddenRow })}
          />
        </td>
      </tr>
      {isVisibleHiddenRow && (
        <tr key={uuidv4()}>
          <EquipmentByFaultTable
            faultId={row.fault_id}
            aiTotal={row.action_items_count}
            isVisibleHiddenRow={isVisibleHiddenRow}
          />
        </tr>
      )}
    </>

  )
}

export default ExpandedRow